export default __webpack_public_path__ + "static/media/symphony.cbdcf314.svg";